import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { SVGFC } from '@repo/toolkit/types'

const ClockIcon: SVGFC = ({ color = tailwindColors.grey.DEFAULT, ...props }) => {
  return (
    <svg
      width="13"
      height="12"
      viewBox="0 0 13 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.0059 12C0.674814 11.9947 -2.00671 5.52037 1.75915 1.74736C3.99466 -0.58228 8.01718 -0.582655 10.2527 1.74745C14.0185 5.52079 11.3367 11.995 6.0059 12ZM6.0059 0.926713C3.2117 0.926713 0.938461 3.19995 0.938461 5.99415C1.21682 12.7168 10.796 12.7148 11.0733 5.9941C11.0733 3.19997 8.80007 0.926713 6.0059 0.926713ZM8.19104 7.51574L6.70863 6.03333C6.72167 5.8144 6.6283 5.60515 6.47487 5.46936C6.47501 5.46446 6.4751 5.45953 6.4751 5.45458V2.70972C6.45033 2.08718 5.56125 2.08765 5.53669 2.70972V5.45458C5.53669 5.45953 5.53678 5.46446 5.53692 5.46936C5.04625 5.90859 5.37911 6.7312 6.04505 6.6969L7.52747 8.17932C7.71069 8.36257 8.00779 8.36257 8.19102 8.17932C8.37427 7.99607 8.37427 7.69899 8.19104 7.51574Z"
        fill={color}
      />
    </svg>
  )
}

export default ClockIcon
